import { render, staticRenderFns } from "./DutyStaff.vue?vue&type=template&id=27ee7b57&scoped=true"
import script from "./DutyStaff.vue?vue&type=script&lang=js"
export * from "./DutyStaff.vue?vue&type=script&lang=js"
import style0 from "./DutyStaff.vue?vue&type=style&index=0&id=27ee7b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee7b57",
  null
  
)

export default component.exports